import { VK } from "./define";

const VirtualKeyMediaKeys: number[] = [
    0xA6,
    0xA7,
    0xA8,
    0xA9,
    0xAA,
    0xAB,
    0xAC,
    0xAD,
    0xAE,
    0xAF,
    0xB0,
    0xB1,
    0xB2,
    0xB3,
    0xB4,
    0xB5,
    0xB6,
    0xB7
]


const VirtualKeyModifierKeys: number[] = [
    0xa0,
    0xa1,
    0xa2,
    0xa3,
    0xa4,
    0xa5,
    0x5b,
    0x5c
]

const VirtualKeyMouseKeys: number[] = [
    0x01,
    0x02,
    0x04,
    0x05,
    0x06,
    0x98,
    0x99,
    0x9a,
    0x9b,
    0x9c,
    0x9d,
    0x9e,
    0x9f,
    0x89,
    0x8a,
]
class DefineType {
    isMedia(vk: VK) {
        return VirtualKeyMediaKeys.includes(vk);
    }

    isMouse(vk: VK) {
        return VirtualKeyMouseKeys.includes(vk);
    }

    isModifier(vk: VK) {
        return VirtualKeyModifierKeys.includes(vk);
    }
}
const defineType = new DefineType();
export default defineType;
